<template>
  <div
    class="news__item news-block"
    role="link"
    tabindex="0"
    :aria-label="cardAriaLabel"
    @click="routerDetail"
    @keydown.enter.prevent="routerDetail"
    @keydown.space.prevent="routerDetail"
  >
    <div class="news-block__img">
      <NewsCropImageView
        v-if="item_news.imageUrl"
        :image-url="item_news.imageUrl"
        :crop-zoom="item_news.imageCropZoom"
        :crop-pan-x="item_news.imageCropPanX"
        :crop-pan-y="item_news.imageCropPanY"
        :alt="item_news.title || 'Обложка новости'"
      />
      <div v-else class="news-block__img-empty" aria-hidden="true">Нет фото</div>
    </div>
    <div class="news-block__info">
      <div class="news-block__date">
        <p class="text-circe-bold-16 color-gray">{{ formatDate(item_news.dateTime) }}</p>
      </div>
      <div class="news-block__title">
        <p class="text-TTDrugs-regular-16">{{ item_news.title }}</p>
      </div>
      <div class="news-block__description">
        <p class="text-circe-14">{{ item_news.description }}</p>
      </div>
      <div class="news-block__btn-wrap">
        <button
          type="button"
          class="button-text news-block__more"
          @click.stop="routerDetail"
        >
          <span class="text-circe-18 color-green">ПОДРОБНЕЕ</span>
          <div class="button-text__img">
            <img src="../../assets/svg/arrow-right.svg" alt="" />
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import NewsCropImageView from '@/components/News/NewsCropImageView.vue'

  export default {
    name: 'SectionItemNews',
    components: { NewsCropImageView },
    props: {
      item_news: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    computed: {
      cardAriaLabel() {
        const title = (this.item_news && this.item_news.title) || 'Новость';
        return `Открыть новость: ${title}`;
      },
    },
    methods: {
      routerDetail() {
        this.$router.push({ name: 'NewsItem', params: { id: this.item_news.id } });
      },
      formatDate(raw) {
        if (!raw) return '';
        const date = new Date(raw);
        if (Number.isNaN(date.getTime())) return String(raw);
        return date.toLocaleDateString('ru-RU', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
      }
    }
  }
</script>

<style scoped>
.news-block__more {
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.news-block__more:focus-visible {
  outline: 2px solid #3a7a3a;
  outline-offset: 3px;
  border-radius: 4px;
}
</style>
